import React from "react";
import Navbar  from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
const RefundPolicy = () => {
    return (
        <div>
        <Navbar/>
        <div style={{padding:60}} >
            <h1>
                Cancellation & Refund Policy for Freshpage: <br /><br />
            </h1>
            <h3> 1. No Refund for Paid Services:</h3><br /><br />
            • Once payment is made for services provided by Freshpage,
            including membership fees or additional delivery services, there will
            be no refund available. We encourage users to carefully review their
            choices before making a payment.<br /><br />
            <h3> 2. Refundable Security Deposit: </h3><br /><br />
            • A refundable security deposit of Rs. 1000 will be required upon
            registration or initiation of the lending process<br /><br />
            If a cancellation request is made within the designated timeframe,
            Freshpage will refund the security deposit within 15 working days.<br /><br />
            • The refund will be processed through the original payment method
            or as mutually agreed upon.<br /><br />
            <h3>3. Membership Cancellation and Book Return:</h3>
            <br /><br />
            Membership cannot be canceled until all borrowed books have been
            returned or delivered to the next borrower, as per Freshpage's
            instructions.<br /><br />
            • Borrowers must follow Freshpage's guidelines for book return or
            delivery, ensuring that books are returned in a timely manner and
            in the same condition as received, considering fair wear and tear<br /><br />
            <h3> 4. Deductions from Security Deposit:</h3><br /><br />
            In the event of significant damage or loss to a borrowed book,
            Freshpage reserves the right to deduct a portion of the security
            deposit to cover the cost of book replacement or repair.<br /><br />
            • The deduction amount will be determined based on the extent of the
            damage or loss, and Freshpage will provide a detailed explanation of
            the deductions made.<br /><br />
            <h3> 5. Communication and Dispute Resolution:</h3><br /><br />
            Any cancellation or refund requests should be communicated to
            Freshpage through the designated channels provided on our
            platform.<br /><br />
            • In the event of disputes or issues related to cancellations or
            refunds, Freshpage will work diligently to resolve them in a fair and
            reasonable manner.<br /><br />
            • Please note that this cancellation and refund policy is designed to
            ensure a smooth and transparent process for our members. By using
            Freshpage's services, users acknowledge and agree to abide by this
            policy.<br /><br />
            <h3>- If you have any questions or require further clarification, please
                reach out to our customer support team for assistance.</h3>
        </div>
        <Footer/>
        </div>
    );
};

export default RefundPolicy;